import '../App.css';
import '../style.css';
import '../font.css';
import './style_works.css';
import { AnimationOnScroll } from 'react-animation-on-scroll';

export function WorkImage(props: {
    image: string; 
    description? : React.ReactNode;
    isMaxheight : boolean;
    isbottomPadding : boolean;
    isRoundedCorner? : boolean;
    isMargin? : boolean;

}) {
    // 기본값을 true로 설정
    const hasMargin = props.isMargin !== false;

    return (
        <>
        <AnimationOnScroll animateIn="fadeIn" animateOnce={true} offset={0}>
        <div className={`image-center ${props.isbottomPadding ? 'bottomPadding':''} ${hasMargin ? 'image-center-margin':''}`}> 
          <img 
            className={`workImage ${props.isMaxheight ? 'maxheight600' : ''} ${props.isRoundedCorner ? 'corner-round24' : ''}`} 
            src = {props.image}
          />
          {props.description && <div className='imageCaption'>
            {props.description}
          </div>}
        </div>
        </AnimationOnScroll>
        </>
    )
}